import {OptimizerParameterCd} from '../';
import {EnumHelper} from './enum-helper';

export class OptimizerParameterCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in OptimizerParameterCd ) {
      this._values.push(OptimizerParameterCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): OptimizerParameterCd {

    for ( const obj in OptimizerParameterCd ) {
      if (OptimizerParameterCd[obj] === value){
        return OptimizerParameterCd[obj] as OptimizerParameterCd;
      }
    }
  }
}

const OptimizerParameterCdHelper = new OptimizerParameterCdHelperEnumHelperClass();
export default OptimizerParameterCdHelper;
